import { render, staticRenderFns } from "./ResultsPositioning.vue?vue&type=template&id=c9f61f0e&"
import script from "./ResultsPositioning.vue?vue&type=script&lang=js&"
export * from "./ResultsPositioning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports